import React, { useState } from 'react'

import Icon from 'components/Icon'
import Link from 'components/Link'
import Typography from 'components/Typography'
import { useEventContext } from 'context/EventContext'

import TrustDrawer from './components/TrustDrawer'

import classes from './TrustBanner.module.scss'

const TrustBanner = () => {
  const [open, setOpen] = useState(false)
  const { sendEvent } = useEventContext()

  const handleOpen = () => {
    setOpen(true)
    sendEvent({
      name: 'engagement_facet_click',
      engagementComponent: 'trust-banner',
      engagementDestination: 'trust-drawer',
      engagementDetails: 'open_trust-drawer',
    })
  }

  const handleClose = () => {
    setOpen(false)
    sendEvent({
      name: 'engagement_facet_click',
      engagementComponent: 'trust-drawer',
      engagementDestination: 'close_trust-drawer',
      engagementDetails: 'icon_close',
    })
  }
  return (
    <div className="TrustBanner">
      <div className={classes.disclaimer}>
        <div className={classes.icon}>
          <Icon icon={['ga', 'logo-square']} />
        </div>

        <Typography>
          GetApp offers objective, independent research and verified user reviews. We may earn a referral fee when you
          visit a vendor through our links.&nbsp;
          <Link onClick={() => handleOpen()} className={classes.link}>
            Learn more
          </Link>
        </Typography>
      </div>
      <TrustDrawer open={open} handleClose={handleClose} />
    </div>
  )
}

export default TrustBanner
